import type { Step1DetectOnPeriodsResponse } from "@/chargeDetection/types"

export interface Step1DetectOnPeriodsResultsProps {
  data: Step1DetectOnPeriodsResponse
}

export function Step1DetectOnPeriodsResults({ data }: Step1DetectOnPeriodsResultsProps) {
  const cycleCount = data.on_periods.length
  const cycleLabel = cycleCount === 1 ? 'cycle' : 'cycles'

  return (
    <div className="space-y-2">
      <div>Found {cycleCount} {cycleLabel}</div>
      <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
        <div className="font-medium mb-1">Selected cycle:</div>
        <div className="font-mono text-xs space-y-1">
          <div>Start: {new Date(data.selected_start).toLocaleString()}</div>
          <div>End: {new Date(data.selected_end).toLocaleString()}</div>
        </div>
      </div>
    </div>
  )
}